module.exports = __webpack_public_path__ + "static/media/robertKellion45.b3c24ed9.png";